/* tslint:disable */

declare var Object: any;
export interface SectorInterface {
  "idsector": number;
  "nombre"?: string;
  "grupo"?: number;
  "orden"?: number;
  "descripcion"?: string;
  "idsectorpadre"?: string;
}

export class Sector implements SectorInterface {
  "idsector": number;
  "nombre": string;
  "grupo": number;
  "orden": number;
  "descripcion": string;
  "idsectorpadre": string;
  constructor(data?: SectorInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Sector`.
   */
  public static getModelName() {
    return "Sector";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Sector for dynamic purposes.
  **/
  public static factory(data: SectorInterface): Sector{
    return new Sector(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Sector',
      plural: 'Sectors',
      path: 'Sectors',
      idName: 'idsector',
      properties: {
        "idsector": {
          name: 'idsector',
          type: 'number'
        },
        "nombre": {
          name: 'nombre',
          type: 'string'
        },
        "grupo": {
          name: 'grupo',
          type: 'number'
        },
        "orden": {
          name: 'orden',
          type: 'number'
        },
        "descripcion": {
          name: 'descripcion',
          type: 'string'
        },
        "idsectorpadre": {
          name: 'idsectorpadre',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/Sector.ts